import { MutationTree } from 'vuex';
import { IContentLinkBlock } from '@/dealroom/content-link/types/content-link';
import { IContentLinkBlockState } from '@/dealroom/content-link/store/content-link.store';

export const mutationSetPreview = 'setPreview';
export const mutationSetLoading = 'setLoading';
export const mutationSetLoaded = 'setLoaded';
export const mutationClearData = 'clearData';
export const mutationSetURLValidation = 'setURLValidation';
export const mutationSetMessage = 'setMessage';

export const mutations: MutationTree<IContentLinkBlockState> = {
  [mutationSetPreview](state: IContentLinkBlockState, contentLinkBlock: IContentLinkBlock) {
    state.preview = { ...state.preview, ...contentLinkBlock };
  },
  [mutationSetLoading](state: IContentLinkBlockState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetLoaded](state: IContentLinkBlockState, loaded: boolean) {
    state.loaded = loaded;
  },
  [mutationClearData](state: IContentLinkBlockState, defaultState: IContentLinkBlockState) {
    state.loaded = defaultState.loaded;
    state.loading = defaultState.loading;
    state.preview = defaultState.preview;
    state.message = defaultState.message;
    state.validUrl = defaultState.validUrl;
  },
  [mutationSetURLValidation](state: IContentLinkBlockState, valid?: boolean) {
    state.validUrl = valid;
  },
  [mutationSetMessage](state: IContentLinkBlockState, message?: string) {
    state.message = message;
  },
};
